<script setup lang="ts">
export type ForkUpdatePopupPayload = {
  filterLength: number
  selectedForkId: string
  selectedLength: number | null
} | null

defineProps<{
  payload: ForkUpdatePopupPayload
}>()
defineEmits<{
  (e: 'confirm'): void
  (e: 'close'): void
}>()
</script>

<template>
  <TheConfirmPopup
    :show="Boolean(payload)"
    :title="$t('calendar.popup.forkUpdate.title')"
    width="1100px"
    :action-button-label="$t('calendar.popup.forkUpdate.accept')"
    :cancel-button-label="$t('calendar.popup.forkUpdate.cancel')"
    @confirm="$emit('confirm')"
    @close="$emit('close')"
  >
    <p v-if="payload">
      {{ $t('calendar.popup.forkUpdate.content.selectedFork', payload) }}
      {{ payload.selectedLength === null
        ? $t('calendar.popup.forkUpdate.content.notDefined', payload)
        : $t('calendar.popup.forkUpdate.content.mismatch', payload)
      }}
    </p>
  </TheConfirmPopup>
</template>
